import React from "react";


const WhoShouldJoin = () => {
  return (
    <div className="who-should-join">
      <h2 className="title">Who Should Join</h2>
      <div className="join-cards">
        <div className="join-card">
          <img src="assets/images/icons/workingProfessionals.png" alt="Working Professional" className="icon" />
          <h3>Working Professionals</h3>
          <ul>
            <li>1–10 yrs experience</li>
            <li>Upskill for ML/DS roles</li>
            <li>Target Product Companies</li>
          </ul>
        </div>
        <div className="divider" />
        <div className="join-card">
          <img src="assets/images/icons/graduated.jpg" alt="Fresh Graduate" className="icon" />
          <h3>Fresh Graduates</h3>
          <ul>
            <li>B.Tech CS students</li>
            <li>Looking for job opportunities</li>
            <li>Need resume & interview help</li>
          </ul>
        </div>
        <div className="divider" />
        <div className="join-card">
          <img src="assets/images/icons/careerpath.jpg" alt="Career Switcher" className="icon" />
          <h3>Architect/Managers</h3>
          <ul>
            <li>Senior Candidates in IT</li>
            <li>Target Architect Roles in Data Science</li>
            <li>Business Analytics Roles</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WhoShouldJoin;
